export function SupportPage() {
  return (
    <div className="container">
      <h1>Поддержка</h1>
      <div className="card">
        <p className="muted" style={{ marginTop: 0 }}>
          Поможем с подключением, оплатой и любыми вопросами по подписке. Обычно отвечаем в течение нескольких часов.
        </p>
      </div>

      <div className="card">
        <h2>Telegram</h2>
        <p className="muted" style={{ marginTop: 0 }}>Самый быстрый способ связаться с нами.</p>
        <a href="https://t.me/orbanvpn_support" target="_blank" rel="noopener">
          <button type="button">Написать в Telegram</button>
        </a>
      </div>

      <div className="card">
        <h2>Электронная почта</h2>
        <p className="muted" style={{ marginTop: 0 }}>Напишите нам на почту — подойдёт для подробных обращений.</p>
        <a href="mailto:info@orbanvpn.com">
          <button type="button" className="secondary">info@orbanvpn.com</button>
        </a>
      </div>
    </div>
  );
}
